import { render } from "./investment.vue?vue&type=template&id=035f940e&scoped=true"
import script from "./investment.vue?vue&type=script&lang=js"
export * from "./investment.vue?vue&type=script&lang=js"

import "./investment.vue?vue&type=style&index=0&id=035f940e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035f940e"]])

export default __exports__